import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "DEMO",
  pwaServiceName: "DEMO",
  appLogoPath: "/partner/larkbc/logo.jpg",
  appLogoHeight: "40px",
  landingLogoPath: "/partner/larkbc/logo.jpg",
  landingLogoHeight: "60px",
  hubLogoPath: "/partner/larkbc/logo.jpg",
  hubLogoHeight: "60px",
  favicon: "/partner/larkbc/logo.jpg",
  pwaIcons: [
    {
      src: "/partner/larkbc/logo.jpg",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "invite@larkbc.pl",
  adminEmail: "admin@larkbc.pl",
  // adminPhoneNumber: "REPLACE_WITH_PHONE",
  reviewLink: null,
  copyright: "LarkBC",
  showLanguageGuides: true,
  bioPrompt: `
    You are a tutor at a language school.
  `,
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-tertiary-600)",
      speakInputRecording: "var(--chakra-colors-brand-tertiary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-tertiary-900)",
    },
  },
  colors: {
    primary: {
      main: "#228C22",
      mainContrast: "#fff",
      "50": "#f3f9f3",
      "100": "#cfe6cf",
      "200": "#a6d0a6",
      "300": "#72b572",
      "400": "#53a653",
      "500": "#299029",
      "600": "#1e7a1e",
      "700": "#186218",
      "800": "#145314",
      "900": "#0f3c0f",
    },
    secondary: {
      main: "#f5b417",
      mainContrast: "#000",
      "50": "#fef7e6",
      "100": "#fbdd97",
      "200": "#f6bd32",
      "300": "#d59c14",
      "400": "#be8c12",
      "500": "#a0760f",
      "600": "#87630d",
      "700": "#6d500a",
      "800": "#5c4309",
      "900": "#423106",
    },
    tertiary: {
      main: "#41246d",
      mainContrast: "#fff",
      "50": "#f8f7f9",
      "100": "#e3dee9",
      "200": "#cac2d6",
      "300": "#ada0c0",
      "400": "#9d8eb3",
      "500": "#8775a3",
      "600": "#756095",
      "700": "#614985",
      "800": "#543a7c",
      "900": "#40236b",
    },
  },
};
